import { useState } from 'react'
import Login from './views/Login/login'
import { Toaster } from 'react-hot-toast'
import TestResult from './views/TestResult/TestResult'

function App() {
  const [result, setResult] = useState(null)

  const handleResult = (data) => {
    setResult(data)
  }

  const handleBack = () => {
    setResult(null)
  }

  return (
    <>
      <div className="App">
        <a href="https://www.malefromhome.com/">
          <img src="/images/mfh-logo.png" alt="mfh-logo" />
        </a>

        {!result ? <Login handleResult={handleResult} /> : <TestResult testResult={result} onBack={handleBack} />}
      </div>
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 5000,
          style: {
            background: '#363636',
            fontSize: '14px',
            fontWeight: '500',
            color: '#fff',
          },
        }}
      />
    </>
  )
}

export default App
